import { styled } from '@mui/material';

export const PropertyPillGroupWrapperStyled = styled('div')(({ theme }) => ({
  '& > *': { marginRight: 20, marginBottom: 10 },
  '& > *:last-of-type': { marginRight: 0 },
}));
